import { render, staticRenderFns } from "./add_compagny.vue?vue&type=template&id=13e038dd&scoped=true"
import script from "./add_compagny.js?vue&type=script&lang=js&external"
export * from "./add_compagny.js?vue&type=script&lang=js&external"
import style0 from "./add_compagny.vue?vue&type=style&index=0&id=13e038dd&prod&lang=scss&scoped=true"
import style1 from "./add_compagny.vue?vue&type=style&index=1&id=13e038dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e038dd",
  null
  
)

export default component.exports